import router from "./config/routes.js";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import store from "./store";
import Auth from "./config/auth";
import Cookies from "js-cookie";
let { isDebug, loginUrl, login_jiuyescm_ticket } = Auth;

function toListDF(array, list = []) {
  for (const item of array) {
    if (item.childrens.length > 0) {
      toListDF(item.childrens, list);
    } else {
      list.push({ menuUrl: item.menuUrl, menuName: item.menuName });
    }
  }
  return list;
}
// 当前环境变量
const NODE_ENV = process.env.NODE_ENV || "development";
Cookies.set("NODE_ENV", NODE_ENV);

NProgress.configure({ showSpinner: false });

router.beforeEach((to, from, next) => {
  NProgress.start();
  // 开发环境生效
  try {
    let storeRoute = store.state.param.userMenus;
    if (storeRoute.length > 0) {
      // hasLocalRouter
      let toRouteInfo = storeRoute.find((item) => item.menuUrl === to.path);
      if (toRouteInfo) {
        let { menuName, menuUrl } = toRouteInfo;
        let component = router.match(menuUrl);
        let tab = {
          label: menuName,
          name: component.name,
          url: menuUrl,
          isActive: false,
          isEnable: true,
        };
        store.dispatch("addToTab", tab);
        store.dispatch("setTabActive", tab);
        store.dispatch("setTabViewName", [tab.name, tab.name]);
        next();
      } else {
        next();
      }
    } else {
      // request userMenus
      store.dispatch("getUserMenu").then((res) => {
        res = res.map((item) => {
          if (item.menuUrl === "/activity-tracking") {
            return { ...item, menuUrl: "/activity-tracking/list" };
          }
          return item
        });
        let menuList = toListDF(res);
        let normalizePath = (path) => path.replace(/\/+$/, '');
        let toRouteInfo = menuList.find((item) => {
          return normalizePath(item.menuUrl) === normalizePath(to.path);
        });
        if (toRouteInfo) {
          let { menuName, menuUrl } = toRouteInfo;
          let component = router.match(menuUrl);
          let tab = {
            label: menuName,
            name: component.name,
            url: menuUrl,
            isActive: false,
            isEnable: true,
          };
          store.dispatch("addToTab", tab);
          store.dispatch("setTabActive", tab);
          store.dispatch("setTabViewName", [tab.name, tab.name]);
          next();
        } else {
          next();
        }
      });
    }
  } catch (error) {
    next();
  }
  next();
  NProgress.done();
});

router.afterEach(() => {
  NProgress.done();
});



// WEBPACK FOOTER //
// ./src/permission.js